<template>
  <div class="chats-inner">
    <!--  todo: メッセージタイプ定義 -->
    <div class="chat-left" v-if="roomMessage.participant_id !== $store.getters['auth/id']">
      <span class="participant-name">{{ participant.name }}</span>
      <div class="face-icon">
        <img :class="{isAdmin: participant.isAdmin()}" :src="participant.avatar" />
      </div>
      <div class="chatting wrapper">
        <p>
          <RawHtml :text="roomMessage.message" />
        </p>
      </div>
    </div>

    <div class="chat-right" v-if="roomMessage.participant_id === $store.getters['auth/id']">
      <p class="wrapper soft">
        <RawHtml :text="roomMessage.message" />
      </p>
    </div>
  </div>
</template>

<script>
import RawHtml from "./RawHtml"

export default {
  name: "RoomMessage",
  components: {RawHtml},
  props: {
    roomMessage: {
      type: Object,
      required: true
    }
  },
  computed: {
    participant() {
      return this.$store.getters["participants/getByUserId"](this.roomMessage.participant_id)
    }
  },
  methods: {
    invertModalStatus() {
      this.$emit("invert-modal-status")
    }
  }
}
</script>
